import { FlexBox } from 'components';
import { CounterP04 } from '../intendendComponents';

const Prac04 = () => {
  const counter = <CounterP04 />;
  return (
    <FlexBox>
      {counter}
      {counter}
    </FlexBox>
  );
};

export default Prac04;
